
import { defineComponent, onMounted, ref, computed } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import Multiselect from "@vueform/multiselect";
import Swal from "sweetalert2/dist/sweetalert2.js";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
// import Dropzone from "dropzone";
import moment from "moment"
import axios from "@/axios-instance"
import * as Yup from "yup";
import Permission from "@/core/config/Permission";

interface IGapTimeActivities {
    "activityName": string;
    "from": string;
    "to": string;
    "ranktime": string[];
    "activityType": string;
    "id": string;
    "label": string;
  
}
interface IPagination {
  currentPage: number;
  total: number;
  limit: number;
}

export default defineComponent({
  name: "gapTimeActivities",
  components: {
    ErrorMessage,
    Field,
    Form,
    Multiselect,
    Datatable,
  },
  emits:['updateData'],
  props: {
    dataForm: Array,
    type: String,
    id: String,
    admissionRegistration: Object,
    //Hồ sơ ĐÃ CHỐT (hoàn tất/đã chuyển giao): khoá thao tác; Superadmin bật "chỉnh sửa" ở Tab1 thì
    //editReason có giá trị -> mở khoá và gắn kèm payload (BE bắt buộc lý do mới cho lưu).
    locked: Boolean,
    editReason: String,
  },
  data() {
    return {
      isEdit: false,
      arrOptions: [
        { value: 'Tiếng Anh', label: 'Tiếng Anh' },
        { value: 'Tiếng Pháp', label: 'Tiếng Pháp' },
        { value: 'Tiếng Nhật', label: 'Tiếng Nhật' },
        { value: 'Tiếng Hàn', label: 'Tiếng Hàn' },
        { value: 'Tiếng Trung', label: 'Tiếng Trung' },
        { value: 'Khác', label: 'Khác' },
      ]
    }
  },
  methods: {
    addTag(newTag) {
      console.log('newTag')
      const tag = {
        value: newTag,
        label: newTag,
      };
      this.arrOptions.push(tag);
    },
    cancle() {
        this.isShowForm = false
        this.isEdit = false
    },
    addRow() {
      this.gapTimeActivities.activityName = ''
      this.gapTimeActivities.label = ''
      this.gapTimeActivities.ranktime = ['','']
      this.isShowForm = true
      this.isEdit = false
    },
    editRow(record) {
      this.isShowForm = true
      this.isEdit = true
      this.gapTimeActivities = JSON.parse(JSON.stringify(record))
      // console.log('this.gapTimeActivities',this.gapTimeActivities)
    },
    deleteRow(record) {
      Swal.fire({
        text: `Bạn có muốn xóa thông tin này?`,
        icon: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Đồng ý",
        cancelButtonText: "Trở lại",
        customClass: {
          confirmButton: "btn btn-primary order-2",
          cancelButton: "btn btn-light order-1",
        },
      }).then(async (result) => {
        if(result.isConfirmed) {
          let index = this.tableData.findIndex((i:any)=>i.id == record.id)
          this.tableData.splice(index,1)
          let tempData = {
            'gapTimeActivities': this.tableData.concat(this.dataGapTimeActivities),
            'admissionRegistration': this.admissionRegistration,
            ...(this.editReason ? { editReason: this.editReason } : {}),
          }
          
          await axios.put(`/applicant/admin/${this.id}`,tempData)
            .then(( {data} ) => {
              this.cancle()
              this.$emit("updateData", data.item.gapTimeActivities);
            })
            .catch(({ response }) => {
                console.log('err',response)
            });
        }
        Swal.close()
    });
    },
    async submit() {
      if (!this.submitButton) { return }
        this.submitButton.validate(async (valid) => {
          if (valid) {
            this.gapTimeActivities.from = this.gapTimeActivities.ranktime[0]!=''?moment(this.gapTimeActivities.ranktime[0]).format('DD/MM/YYYY'):''
            this.gapTimeActivities.to = this.gapTimeActivities.ranktime[1]!=''?moment(this.gapTimeActivities.ranktime[1]).format('DD/MM/YYYY'):''
            if(this.isEdit) {
              let record = JSON.parse(JSON.stringify(this.gapTimeActivities))
              let index = this.tableData.findIndex((i:any)=>i.id == record.id)
              this.tableData[index] = record as any
            }
            else {
              this.gapTimeActivities.id = this.tableData.length.toString()
              this.gapTimeActivities.activityType = this.type as any
              let record = JSON.parse(JSON.stringify(this.gapTimeActivities))
              this.tableData.push(record as any)
            }
            let tempData = {
              'gapTimeActivities': this.tableData.concat(this.dataGapTimeActivities),
              'admissionRegistration': this.admissionRegistration,
            ...(this.editReason ? { editReason: this.editReason } : {}),
            }
            await axios.put(`/applicant/admin/${this.id}`,tempData)
            .then(( {data} ) => {
              this.isShowForm = false
              // console.log(data)
              if(!this.isEdit) {
                  this.$emit("updateData", data.item.gapTimeActivities);
              }
            })
            .catch(({ response }) => {
              console.log('err',response)
            });
          }
        })
      
    },
    
  },

  setup(props) {
    const textErr = 'Vui lòng điền trường này'
    const validator = ref({
      activityName: [{
        required: true,
        message: textErr,
        trigger: "change",
        },
      ],
      label: [{
        required: true,
        message: textErr,
        trigger: "change",
        },
      ],
      ranktime: [{
        required: true,
        message: textErr,
        trigger: "change",
        },
      ],
    })
    const isShowForm = ref(false)
    const pagination = ref<IPagination>({
      currentPage: 1,
      total: 0,
      limit: 50,
    });
    const submitButton = ref()
    const formRef = ref()
    
    const currentDataForm = computed(() => {
        return props.dataForm
    })
    const tableData = ref<Array<IGapTimeActivities>>([]);
    const tableHeader = ref([
      {
        name: "Ngoại ngữ",
        key: "label",
        sortable: false,
        class: "",
      },
      {
        name: "Nơi học",
        key: "activityName",
        sortable: false,
        class: "",
      },
      {
        name: "Thời gian",
        key: "time",
        sortable: false,
        class: "",
      },
      {
        name: "Hành động",
        key: "actions",
        sortable: false,
        class: "text-center"
      },
    ]);
   
    const gapTimeActivities =  ref<IGapTimeActivities>({
        "activityName": "",
        "from": "",
        "to": "",
        "ranktime": [],
        "activityType": "",
        "id": "",
        "label": "",
    })
    const dataGapTimeActivities = ref<Array<IGapTimeActivities>>([]);
    onMounted(async () => {
        currentDataForm.value?.forEach((item:any)=>{
          if(item.activityType == props.type) {
            tableData.value.push(item)
          }
          else {
              dataGapTimeActivities.value.push(item)
          }
        })
    })
    return {
      tableHeader,
      tableData,
      pagination,
      isShowForm,
      gapTimeActivities,
      dataGapTimeActivities,
      validator,
      submitButton,
      formRef,
      Permission,
    };
  },
});
